/*
 * Lemonade Training Oy, copy rights, all right reserved.
 */

import { isTimeFormatPreference } from "@lemonadetraining/contracts";
import { createPreferenceMirror } from "./preferenceMirror";

/** Device-local echo of Users/{uid}/Settings/preferences.timeFormat. */
export const TIME_FORMAT_STORAGE_KEY = "lemonade-time-format";

const mirror = createPreferenceMirror({
  key: TIME_FORMAT_STORAGE_KEY,
  field: "timeFormat",
  isValid: isTimeFormatPreference,
  fallback: "system",
});

export const readTimeFormatMirror = mirror.read;
export const readTimeFormatMirrorUid = mirror.readUid;
export const writeTimeFormatMirror = mirror.write;
export const clearTimeFormatMirror = mirror.clear;
